import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Most of the technical-changes work should be for ootb or planning tech changes
 *
 * @returns `true` when one of the technical changes flags are on
 */
export const isPlanWorkItemTechChangesEnabled = (): boolean =>
	fg('jira_ai_task_level_planning_ootb_agent') ||
	fg('jira-ai-agentic-planning-technical-changes') ||
	fg('jira-ai-repo-selection-technical-extraction');
